<template>
  <div class="max-w-1471">
    <div class="lg:flex">
      <div class="py-9 overflow-x-scroll flex px-5 disable-scrollbars lg:grid lg:grid-cols-2 lg:gap-3 lg:px-3">
        <div v-for="image in images" :key="image.fallback" class="scroll-item pr-3 lg:px-0">
          <OImage
            v-bind="image"
            img-class="rounded"
            :alt="$t('Accessibilty.AltTags.WomenProductImage')"
          />
        </div>
      </div>
      <div class="px-3 max-w-351 lg:pt-9">
        <h1 class="text-women-text o-heading-2 capitalize mb-6" v-text="$t('LandingsPage.Women.Product.ProductInformation')" />
        <Faq
          class="text-women-text"
          :initial-open-index="0"
          :items="faqItems"
        />
        <div class="mt-6 mb-20 pb-1">
          <NewButton color="women" tag="nuxt-link" to="/women/signup" class="w-full" icon-right="new-chevron-right">
            {{ $t('LandingsPage.Women.Product.TryForFree') }}
          </NewButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Orientations } from '@/enums/products'
import { getImagePaths } from '@/utils/general'
import OImage from '@/components/OImage'
import Faq from '@/components/Faq'
import NewButton from '@/components/NewButton'

export default {
  name: 'WomenProduct',
  layout: 'homepage',
  components: { OImage, Faq, NewButton },
  data () {
    return {
      latestDesign: {
        [Orientations.womenbralette]: 'camila',
        [Orientations.womenhipster]: 'dani'
      }
    }
  },
  computed: {
    images () {
      return [...Array(4)].map((_, index) => getImagePaths({ path: `/images/design-women/${this.latestDesign[Orientations.womenhipster]}/info/${this.latestDesign[Orientations.womenhipster]}-women-${index + 1}`, s3: true }))
    },
    faqItems () {
      const path = 'LandingsPage.Women.Product.FAQ'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, i) => ({
        title: this.$t(`${path}[${i}].Title`, this.variables),
        description: this.$t(`${path}[${i}].Description`, this.variables)
      }))
    }
  }
}
</script>

<style scoped lang="postcss">
.oimage >>> img {
  max-width: unset !important;
  max-height: unset !important;
}

.overflow-x-scroll {
  scroll-snap-type: x mandatory;
}

.font-normal {
  @apply font-normal !important;
  font-weight: 400 !important;
}

.scroll-item {
  scroll-snap-align: center;
}

>>> .faq {
  @apply border-none rounded-none mb-0 text-women-text !important;

  &-body {
    @apply px-0 text-women-text;
  }

  &-description {
    @apply px-0;

    p {
      @apply pb-5;
    }

    ul {
      @apply list-disc list-inside;

      li::marker {
        @apply bg-women-text text-women-text;
      }
    }
  }
}

>>> .faq {
  border-top: 1px solid #A3A3A3 !important;
}

@screen lg {
  .oimage >>> img {
    max-width: 100% !important;
    max-height: 100% !important;
    @apply w-full h-full object-cover !important;
  }

  .max-w-351 {
    max-width: 35.1rem;
    @apply ml-auto;
  }

  .max-w-1471 {
    max-width: 147.1rem;
    @apply mx-auto;
  }
}
</style>
